import enLang from './entries/en_US';
import faLang from './entries/fa_IR';

const AppLocale = {
    en: enLang,
    fa: faLang
};

export default AppLocale;